import { atom } from "recoil";

export const spineImageState = atom<File | null>({
  key: `spineImage`,
  default: null,
});
